<script setup lang="ts">
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { locale } = useI18n();

const { tiptappAd } = await useTiptappAd(props.blok.adId, locale);

const { marketToCountry, defaultMarket, markets } = useAppConfig();

const route = useRoute();

const marketInQuery = (route.query.market as Market | undefined) || defaultMarket;
const market: Market = marketInQuery in markets ? marketInQuery : defaultMarket;

const country = ref(marketToCountry[market]);

const inviteCode = computed(() => {
    return (
        { de: 'fbShareDE', gb: 'fbShareUK', pt: 'fbSharePT', se: 'fbShareSE' }[
            country.value as string
        ] || 'fbShareSE'
    );
});

const title = computed(() => {
    const title = props.blok.title;
    if (tiptappAd.value) {
        return title
            .replaceAll('{{adTitle}}', tiptappAd.value.title)
            .replaceAll('{{completedIn}}', tiptappAd.value.completedIn || '');
    } else {
        return title;
    }
});

const body = computed(() => {
    const body = props.blok.body;
    if (tiptappAd.value) {
        return body.replaceAll('{{adTitle}}', tiptappAd.value.title);
    } else {
        return body;
    }
});
</script>

<template>
    <section
        ref="root"
        class="relative bg-no-repeat bg-cover bg-center bg-gray-300 bg-blend-multiply pt-16 lg:pt-24"
        :style="`background-image: url('${blok.image.filename}/m/1000x0')`"
    >
        <div class="absolute inset-0" style="mix-blend-mode: multiply"></div>
        <div
            class="bg-gradient-to-t from-[rgba(0,0,0,0.5)] bg-blend-multiply h-[500px] relative flex items-center justify-center"
        >
            <div class="absolute bottom-0 mx-auto pb-8 px-8 text-center">
                <h2 class="mb-4 leading-none text-white font-bold">
                    {{ title }}
                </h2>
                <p class="mb-8 text-lg font-normal text-white lg:text-xl">
                    {{ body }}
                </p>
                <CampaignForm :code="inviteCode" v-model:country="country" />
            </div>
        </div>
    </section>
</template>
